import { render, staticRenderFns } from "./import-dialog.vue?vue&type=template&id=45ed5134&scoped=true&"
import script from "./import-dialog.vue?vue&type=script&lang=js&"
export * from "./import-dialog.vue?vue&type=script&lang=js&"
import style0 from "./import-dialog.vue?vue&type=style&index=0&id=45ed5134&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ed5134",
  null
  
)

export default component.exports